(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gosub-migration-schedule"] && !Shopify.designMode) return;
  try {
    
  window.GosubScheduleTabs = window.GosubScheduleTabs || (function () {
    var activeByLead = {};

    function wrapperOf(root) {
      return root.closest('.shopify-section') || root.closest('.index-section');
    }
    function sectionOf(root) {
      return root.closest('.index-section');
    }

    function activate(group, index) {
      group.forEach(function (root, i) {
        var show = i === index;
        root.querySelector('.gs-panel').style.display = show ? '' : 'none';
        if (i > 0) wrapperOf(root).style.display = show ? '' : 'none';
        var tab = group[0].querySelectorAll('.gs-tab')[i];
        if (tab) {
          tab.setAttribute('aria-selected', show ? 'true' : 'false');
          tab.tabIndex = show ? 0 : -1;
        }
      });
      // Keep the tabs and the active panel together without the gap between sections.
      sectionOf(group[0]).style.marginBottom = index > 0 ? '0' : '';
      activeByLead[group[0].id] = index;
      window.dispatchEvent(new Event('resize'));
    }

    function reset() {
      document.querySelectorAll('.gosub-schedule .gs-tabs').forEach(function (nav) {
        nav.remove();
      });
      document.querySelectorAll('.gosub-schedule').forEach(function (root) {
        root.classList.remove('gs-tab-follower');
        root._gsGroup = null;
        var panel = root.querySelector('.gs-panel');
        if (panel) panel.style.display = '';
        var wrapper = wrapperOf(root);
        if (wrapper) wrapper.style.display = '';
        var section = sectionOf(root);
        if (section) {
          section.style.marginTop = '';
          section.style.marginBottom = '';
          section.style.paddingTop = '';
        }
      });
    }

    function init() {
      reset();
      var groups = [];
      var prev = null;
      document.querySelectorAll('.gosub-schedule[data-tab-label]').forEach(function (root) {
        if (prev && wrapperOf(prev).nextElementSibling === wrapperOf(root)) {
          groups[groups.length - 1].push(root);
        } else {
          groups.push([root]);
        }
        prev = root;
      });

      groups.forEach(function (group) {
        if (group.length < 2) return;
        var lead = group[0];
        var nav = document.createElement('div');
        nav.className = 'gs-tabs';
        nav.setAttribute('role', 'tablist');

        group.forEach(function (root, i) {
          var tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'gs-tab';
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', root.querySelector('.gs-panel').id);
          tab.textContent = root.getAttribute('data-tab-label');
          tab.addEventListener('click', function () {
            activate(group, i);
          });
          tab.addEventListener('keydown', function (event) {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            var next = (i + (event.key === 'ArrowRight' ? 1 : group.length - 1)) % group.length;
            activate(group, next);
            nav.children[next].focus();
          });
          nav.appendChild(tab);

          root._gsGroup = { group: group, index: i };
          if (i > 0) {
            root.classList.add('gs-tab-follower');
            // The theme adds top spacing as margin and, on a section's first element, padding.
            sectionOf(root).style.marginTop = '0';
            sectionOf(root).style.paddingTop = '0';
          }
        });

        lead.insertBefore(nav, lead.querySelector('.gs-panel'));
        var stored = activeByLead[lead.id] || 0;
        activate(group, stored < group.length ? stored : 0);
      });
    }

    // Theme editor: show the tab that holds the selected section or block.
    function selectFrom(target) {
      var root = target && target.querySelector
        ? target.closest('.gosub-schedule') || target.querySelector('.gosub-schedule')
        : null;
      if (root && root._gsGroup) activate(root._gsGroup.group, root._gsGroup.index);
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function () {
      setTimeout(init);
    });
    document.addEventListener('shopify:section:reorder', init);
    document.addEventListener('shopify:section:select', function (event) {
      selectFrom(event.target);
    });
    document.addEventListener('shopify:block:select', function (event) {
      selectFrom(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      setTimeout(init);
    }

    return { init: init };
  })();

  (function () {
    // Sync each chart's pinned header with its horizontally scrolling body.
    function bindScrollSync(root) {
      if (root._gsScrollBound) return;
      var head = root.querySelector('.gs-head-scroll');
      var body = root.querySelector('.gs-scroll');
      if (!head || !body) return;
      root._gsScrollBound = true;
      body.addEventListener('scroll', function () {
        head.scrollLeft = body.scrollLeft;
      }, { passive: true });
    }

    // Stick below the site header while it is visible (sticky header), otherwise at the very top.
    var ticking = false;
    function updateTop() {
      ticking = false;
      var siteHeader = document.querySelector('.site-header');
      var bottom = siteHeader ? siteHeader.getBoundingClientRect().bottom : 0;
      document.documentElement.style.setProperty('--gs-sticky-top', Math.max(0, Math.round(bottom)) + 'px');
    }
    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateTop);
      }
    }

    function init() {
      document.querySelectorAll('.gosub-schedule').forEach(bindScrollSync);
      updateTop();
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
